import { getProductCategory } from '@helpers/products'
import { getValueFromObject } from '@helpers/utils'
import { Collection } from 'types/collection'

export function getCollectionProductCategory(collections: Collection[] = []) {
  const categories: string[] = []
  collections.forEach(collection => {
    const productCategory = getProductCategory(
      getValueFromObject(collection, 'items[0].options', []),
      collection.product_type
    )

    if (productCategory) {
      categories.push(productCategory.toLowerCase())
    }
  })

  const uniqueCategories = [...new Set(categories)]

  return uniqueCategories[0]
}
